import React from 'react';


const SidebarWrap = () => {

    const SubmitHandler = (e) =>{
       e.preventDefault()
    }


    return(
        <div className="col col-lg-4 col-12">
            <div className="wpo-blog-sidebar">
                {/*
                <div className="widget recent-post-widget">
                    <h3>Upcoming Event</h3>
                    <div className="posts">
                        <div className="post">
                            <div className="img-holder">
                                <img src={""} alt=""/>
                            </div>
                            <div className="details">
                                <h4><Link href="/event-single">Many Children are suffering a lot for food.</Link></h4>
                                <span className="date">22 Sep 2021</span>
                            </div>
                        </div>
                        <div className="post">
                            <div className="img-holder">
                                <img src={""} alt=""/>
                            </div>
                            <div className="details">
                                <h4><Link href="/event-single">Be kind for the poor people and the kids.</Link></h4>
                                <span className="date">22 Sep 2021</span>
                            </div>
                        </div>
                        <div className="post">
                            <div className="img-holder">
                                <img src={""} alt=""/>
                            </div>
                            <div className="details">
                                <h4><Link href="/event-single">Be soft and kind for the poor people.</Link></h4>
                                <span className="date">22 Sep 2021</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="widget tag-widget">
                    <h3>Tags</h3>
                    <ul>
                        <li><Link href="/event-single">Salat</Link></li>
                        <li><Link href="/event-single">Quran</Link></li>
                        <li><Link href="/event-single">Books</Link></li>
                        <li><Link href="/event-single">Education</Link></li>
                        <li><Link href="/event-single">World Wide</Link></li>
                        <li><Link href="/event-single">Marriage</Link></li>
                        <li><Link href="/event-single">Hajj</Link></li>
                        <li><Link href="/event-single">Health</Link></li>
                    </ul>
                </div>
                */}
            </div>
        </div>
     )

}

export default SidebarWrap;
